import React from 'react';
import PropTypes from 'prop-types';

import { Radio } from './styles';

const Cell = ({
  companyId, name, checked, onChange,
}) => {
  if (companyId && companyId !== 'global') {
    return (
      <>
        <Radio
          label="Use global"
          name={name}
          checked={checked}
          value
          onChange={onChange}
        />
        <Radio
          label="Always off"
          name={name}
          checked={!checked}
          value={false}
          onChange={onChange}
        />
      </>
    );
  }
  return (
    <Radio
      toggle
      name={name}
      checked={checked}
      onChange={onChange}
    />
  );
};

Cell.propTypes = {
  companyId: PropTypes.string,
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

Cell.defaultProps = {
  companyId: null,
};

export default Cell;
